import { useLazyQuery, useMutation } from "@apollo/client";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CREATE_EMT_ACCOUNT,
  EDIT_EMT_ACCOUNT,
  EMTAccountById,
  GrtPreferenceByFormKey,
  MERGE_ACCOUNT,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import { useGetPageData } from "../../../custom_hooks/useGetPageData";
import Button from "../../Button/Button";
import { handleFormReset, updateSingleField, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import ".././FormComponent.scss";
import "../AddCustomerAccount/AddCustomerAccount.scss";
import { VendorRemarksData } from "../AddVendorAccount/AddVendorAccount.config";
import VendorRemarks from "../AddVendorAccount/AddVendorAccountSection/Remarks";
import UserPreference from "../AddVendorAccount/UserPreferenceAndVehicleCategory/UserPreference";
import VehicleCategorySelection from "../AddVendorAccount/UserPreferenceAndVehicleCategory/VehicleCategorySelection";
import ViewVendorFiles from "../AddVendorAccount/ViewFiles";
import { controlData, DefaultEmtAccountConfiguration } from "./AddEmtAccount.config";
import AddEmtAccountSection from "./AddEmtAccountSection/AddEmtAccountSection";
import { AddUser } from "./AddUser";
import { IoSettingsOutline } from "react-icons/io5";
import { FormConfiguration } from "../../FormConfiguration/FormConfiguration";
import extractCustomFields from "../../../CommonFunction/extractCustomFields";
import processFormDataWithCustomFields from "../../../CommonFunction/processFormDataWithCustomFields";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";
import { AccountGroupData } from "../AddAccountGroup/AddAccountGroup.config";

const AddEmtAccount = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  console.log(show, TypeOfPortal, submitType, "hiii");
  const Form_Key = TypeOfPortal === "Merge" ? "Emt_Accounts_Merge" : "Emt_Accounts";
  const formRef = useRef({});
  const { pushModal, popModal } = useModalContext();
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Emt Account");
  const [showUserPreference, setShowUserPreference] = useState(false);
  const [ShowInfoModal, setShowInfoModal] = useState(false);
  const [openSetting, setOpenSetting] = useState(false);

  // const Tab = useSelector((store) => store.SelectedTabData.tab);
  const fieldDataRedux = useSelector((store) => store.UniqueTableReducer);
  const fieldData =
    fieldDataRedux?.["Emt_Accounts"]?.Selected_Row ||
    fieldDataRedux?.["AccountActivity"]?.Selected_Row ||
    fieldDataRedux?.["Lane_Not_Emt_Accounts"]?.Selected_Row ||
    fieldDataRedux?.["KYC_Not_Emt_Accounts"]?.Selected_Row;
  const [toggle, setToggle] = useState(show ? show : false);
  // const [allData, setAllData] = useState({});
  const [allFieldsData, setAllFieldsData] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [openAddUser, setOpenAddUser] = useState(false);
  const [preferedVehicle, setPreferedVehicle] = useState([]);
  const [preferedFromCityLane, setPreferedFromCityLane] = useState([]);
  const [preferedToCityLane, setPreferedToCityLane] = useState([]);
  const [showVehicleCategory, setShowCategory] = useState(false);
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  // const [accountId, setAccountId] = useState("");
  const { fields } = useGetPageData();
  const [FormData, setFormdata] = useState({});
  const [RemarkFields, SetRemarkFields] = useState(VendorRemarksData["Is_Verified"]);
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [Remark, setRemark] = useState({
    Verified_Remark: "",
  });
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [loadingState, setLoadingState] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [storeCustomFields, setStoreCustomFields] = useState([]);
  const [initialData, setInitialData] = useState({})
  const { isDisabled } = useIsDisabled({ TypeOfPortal, initial: initialData, current: FormData });

  // Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });
  const [GetDefaultAccountGroup] = useLazyQuery(AccountGroupData)
  const [CreatingData, { loading: createEmtAccountLoading }] = useMutation(CREATE_EMT_ACCOUNT, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [GetDataByID, { loading: GetDataByIDLoader }] = useLazyQuery(EMTAccountById, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [EditingData, { loading: editEmtAccountLoading }] = useMutation(EDIT_EMT_ACCOUNT(fields), {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [MergingData, { loading: MergeEmtAccountLoading }] = useMutation(MERGE_ACCOUNT, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [getDataByKey, { loading: userPreferenceLoading }] = useLazyQuery(GrtPreferenceByFormKey, {
    variables: {
      Form_Key: Form_Key,
    },
    fetchPolicy: "network-only",
  });

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  const dispatch = useDispatch();
  const CustomerLoadingState =
    createEmtAccountLoading ||
    editEmtAccountLoading ||
    MergeEmtAccountLoading ||
    GetDataByIDLoader ||
    getFormFieldsLoading ||
    userPreferenceLoading;

  const getDefaultValues = async () => {
    GetDefaultAccountGroup({
      variables: {
        keyword: "Sundary Creditor"
      }
    }).then(({ data }) => {
      console.log(data)
      let group = data?.searchAccountGroups[0]

      updateValueForm(formRef, {
        Account_Group: group?.Search_Value,
        Balance_Method: true,
      });
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: {
            Account_Group: group
          },
        },
      });
    })
  };

  useEffect(() => {

    getFormSectionAndFields().then(() => {
      if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") {
        GetDataByID({
          variables: {
            accountId: fieldData?._id,
          },
        }).then(({ data }) => {
          let accountClone = { ...data?.Account };
          console.log(accountClone, "accountClone");
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Account_Group: accountClone?.Account_GroupsData,
                Account_Manager: accountClone.Account_ManagerData,
                Called_By: accountClone.Called_ByData,
              },
            },
          });
          accountClone.Balance_Method = "Bill By Bill" ? true : false;
          if (accountClone && accountClone.Account_GroupsData) {
            accountClone.Account_Group = accountClone.Account_GroupsData.Account_Group;
          }
          if (accountClone && accountClone.Account_ManagerData) {
            accountClone.Account_Manager = accountClone.Account_ManagerData.Full_Name;
          }
          if (accountClone && accountClone.Called_ByData) {
            accountClone.Called_By = accountClone.Called_ByData.Full_Name;
          }
          if (accountClone?.customFieldData && typeof accountClone.customFieldData === "object") {
            Object.entries(accountClone.customFieldData).forEach(([key, value]) => {
              accountClone[key] = value ?? ""; // Assign value or empty string if undefined/null
            });
          }
          setAllFieldsData(accountClone);
          console.log(accountClone, "accountClone");
          updateValueForm(formRef, accountClone);
        });
      } else if (fieldData) {
        getDefaultValues();
        setAllFieldsData({ CreateCSUser: true, CreateCSUserdisable: true });
        updateSingleField(formRef, "Balance_Method", true);
        updateSingleField(formRef, "CreateCSUser", true);
        updateSingleField(formRef, "CreateCSUserdisable", true);
      }
    });
  }, [JSON.stringify(fieldData)]);

  useEffect(() => {
    if (allFieldsData) {
      // updateValueForm(formRef, allFieldsData);
      if (allFieldsData?.VehicleTypeData) {
        setPreferedFromCityLane(allFieldsData?.LaneData?.From_Location);
        setPreferedToCityLane(allFieldsData?.LaneData?.To_Location);
        // let vehicleIds = allFieldsData?.VehicleTypeData[0]?.Vehicle_Category_Management.map((e)=> e._id)
        setPreferedVehicle(allFieldsData?.VehicleTypeData[0]?.Vehicle_Category_Management);
        // setAccountId(allFieldsData._id);
      }
    }
  }, [allFieldsData]);
  useEffect(() => {
    if (isFirstLoad) {
      setShowRemarkModal(FormData?.Not_Intrested);
      SetRemarkFields(VendorRemarksData["Not_Intrested"]);
    }
  }, [FormData?.Not_Intrested]);
  useEffect(() => {
    if (isFirstLoad) {
      setShowRemarkModal(FormData?.Is_Verified);
      SetRemarkFields(VendorRemarksData["Is_Verified"]);
    }
  }, [FormData?.Is_Verified]);
  formRef.current.OpenReviewModal = (fieldName) => {
    setShowInfoModal(true);
    SetRemarkFields(VendorRemarksData[fieldName.name] || fieldName);
  };
  const HanldeChangeonForm = (values) => {
    setFormdata(prev => {
      const next = { ...prev, ...values };
      if (!isFirstLoad) {
        setInitialData(next)
      }
      return next
    })
  };

  console.log(FormData, "Formadeta-deta");
  useEffect(() => {
    setSelectedRows(fieldDataRedux?.[Form_Key]?.Selected_Rows);
  }, [fieldDataRedux]);

  useEffect(() => {
    setLoadingState(loadingState);
  }, [loadingState]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);

  // This code snippet dynamically manages CRUD (Create, Read, Update, Delete) for Brief Understanding Refer MD Documentation in FormComponents,

  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let newFormData = { ...FormData, ...Remark };

  if (operationType === "Merge") {
    newFormData.existingId = fieldData?._id;
    newFormData.newId = FormDataFromRedux?.MasterData?.[Form_Key]?.replace_with?._id;
  }
  console.log(newFormData, "newFormDatanewFormDatanewFormData");
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, newFormData, selectedRows);

  const mutationFunctions = {
    CreatingData,
    EditingData,
    MergingData,
  };

  useEffect(() => {
    if (inputFields && inputFields?.length > 0) {
      const fields = extractCustomFields(inputFields);
      setStoreCustomFields(fields);
    }
  }, [inputFields]);

  const submit = async (closeAction) => {
    let formData = processFormDataWithCustomFields(newFormData, storeCustomFields);
    formData.Account_Manager = FormDataFromRedux?.MasterData[Form_Key]?.Account_Manager?._id;
    formData.Called_By = FormDataFromRedux?.MasterData[Form_Key]?.Called_By?._id || null;
    formData.Account_Group = FormDataFromRedux?.MasterData[Form_Key]?.Account_Group?._id;
    formData.Is_Verified = formData.Is_Verified || false;
    formData.Is_Document_Verified = formData.Is_Document_Verified || false;
    formData.Is_Lock = formData.Is_Lock || false;
    formData.Is_Mobile_Number_Verified = formData.Is_Mobile_Number_Verified || false;
    formData.Is_Email_Verified = formData.Is_Email_Verified || false;
    formData.Is_Aadhar_Verified = formData.Is_Aadhar_Verified || false;
    formData.Is_Pan_Verified = formData.Is_Pan_Verified || false;
    formData.Is_Gst_Verified = formData.Is_Gst_Verified || false;
    formData.Is_Bank_Verified = formData.Is_Bank_Verified || false;
    formData.KYC_Complete = formData.KYC_Complete || false;
    formData.CreateCSUser = formData.CreateCSUser || false;
    formData.Balance_Method = formData.Balance_Method ? "Bill By Bill" : "Balance only";
    delete formData.accountgroups;

    if (operationType !== "Delete") {
      // Ensure Aadhar_Number is treated as a string
      delete formData.City;
      delete formData.State;
      if (formData.Aadhar_Number && typeof formData.Aadhar_Number !== "string") {
        formData.Aadhar_Number = formData.Aadhar_Number.toString();
      }
      // Apply the replace operation to remove non-numeric characters if Aadhar_Number exists
      if (formData.Aadhar_Number) {
        formData.Aadhar_Number = formData.Aadhar_Number.replace(/[^0-9]/g, "");
      }
    }

    const mutationFunction = getMutationFunction(operationType, mutationFunctions);

    const executeOperationFunction = () => {
      console.log(variables, "variablesvariablesvariables");
      return executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: true,
        PageName: Form_Key,
        OnSuccess: () => {
          handleFormReset(formRef);
        },
      });
    };
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: CloseFormFunction,
      resetFormDataFunction: setAllFieldsData,
      onSuccess: () => { },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const CloseFormFunction = useCallback(() => {

    ParentPortalCloseFunction();
    setToggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
  }, [ParentPortalCloseFunction, Form_Key, dispatch]);

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const HandleSettingClick = () => {
    setOpenSetting(true);
  };


  const HandleRemarkChange = (e) => {
    setRemark((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => (
        <>
          {
            <>
              {TypeOfPortal === "Edit" && (
                <>
                  <Button action={() => setOpenAddUser(true)} name="modalbutton" text="Add User" />
                  {(allFieldsData?.Profile_Type === "Transporter_Commission_Agent" || allFieldsData?.Profile_Type === "Fleet_Owner" || allFieldsData?.Profile_Type === "Single_Truck_Owner_Driver") && (
                    <>
                      <Button action={() => setShowUserPreference(true)} name="modalbutton" text="Preferred Lane" />
                      <Button action={() => setShowCategory(true)} name="modalbutton" text="Preferred Vehicle Type" />
                    </>
                  )}
                </>
              )}
            </>
          }
        </>
      )}
      disabled={isDisabled}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => {
            Validate_handleSubmit(SaveAndCloseForAdd);
          }
          : () => {
            Validate_handleSubmit(submit);
          }
      }
      handleformclose={() => {
        CloseFormFunction();
        setToggle(!toggle);
      }}
      loadingState={CustomerLoadingState}
    />
  );

  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={CloseFormFunction}
          TypeOfPortal={modifiedTypeOfPortal}
          TypeOfId={``}
          id={allFieldsData?.Unique_Id}
          AdditionalContent={() => {
            return (
              <span onClick={HandleSettingClick} className="settingIcon">
                <IoSettingsOutline className="settingIcon" />
              </span>
            );
          }}
        >
          <div className="CustomerAccountSection">
            {CustomerLoadingState && <div className="loader-line-div" />}
            <div className="formContainer">
              {inputFields && inputFields?.length > 0 ? (
                inputFields?.map((e) => (
                  <>
                    <AddEmtAccountSection
                      inputfields={e.fields}
                      Type={e.name}
                      Data={e}
                      TypeOfPortal={TypeOfPortal}
                      controlData={controlData}
                      handleErrorsChange={handleErrorsChange}
                      HanldeChangeonForm={HanldeChangeonForm}
                      formkey={Form_Key}
                      formRef={formRef}
                      setFirstLoad={setFirstLoad}
                      isFirstLoad={isFirstLoad}
                    />
                  </>
                ))
              ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
                <p>No form fields available.</p>
              ) : null}
            </div>
          </div>
        </Reactportal>
      </div>
      {openSetting && (
        <FormConfiguration
          show={openSetting}
          ParentClosingFunction={setOpenSetting}
          config={DefaultEmtAccountConfiguration}
          HanldeChangeonForm={HanldeChangeonForm}
          formRef={formRef}
          allFieldsData={allFieldsData}
          getFormSectionAndFields={getFormSectionAndFields}
          ToGetDefaultValues={() => {
            getDefaultValues();
          }}
          formKey={Form_Key}
          forFormValues={FormData}
          preference={false}
        />
      )}

      {openAddUser && (
        <AddUser
          show={openAddUser}
          TypeOfPortal={TypeOfPortal}
          fielddata={allFieldsData}
          submitType={submitType}
          AccountId={fieldData._id}
          setOpenAddUser={setOpenAddUser}
        />
      )}
      {showUserPreference && (
        <UserPreference
          show={true}
          TypeOfPortal={TypeOfPortal}
          vehicleIds={preferedVehicle}
          formCities={preferedFromCityLane}
          toCities={preferedToCityLane}
          setPreferedVehicle={(val) => setPreferedVehicle(val)}
          setShowModal={() => setShowUserPreference(false)}
          setPreferedFromCityLane={(val) => setPreferedFromCityLane(val)}
          setPreferedToCityLane={(val) => setPreferedToCityLane(val)}
          allFieldsData={allFieldsData}
        />
      )}
      {showVehicleCategory && (
        <VehicleCategorySelection
          show={true}
          setShowModal={() => setShowCategory(false)}
          vehicleIds={preferedVehicle}
          setPreferedVehicle={(val) => setPreferedVehicle(val)}
          allFieldsData={allFieldsData}
        />
      )}
      {showRemarkModal && (
        <VendorRemarks
          show={showRemarkModal}
          onhandleFormikChange={HandleRemarkChange}
          field={RemarkFields}
          values={Remark}
          setShowModal={() => setShowRemarkModal(false)}
        />
      )}
      {ShowInfoModal && (
        <ViewVendorFiles
          Values={formRef?.current?.Controls?.values}
          show={true}
          TypeOfPortal={TypeOfPortal}
          setShowModal={() => setShowInfoModal(false)}
          accountId={fieldData?._id}
          Remark={Remark}
          Type={
            RemarkFields.name === "Is_Pan_Verified"
              ? "PAN"
              : RemarkFields.name === "Is_Gst_Verified"
                ? "GST"
                : RemarkFields.name === "Is_Aadhar_Verified"
                  ? "Aadhaar"
                  : RemarkFields.name === "Verified_Remark"
                    ? "verified"
                    : RemarkFields.name === "Not_Intrested_Remark"
                      ? "Not_Intrested"
                      : "Bank"
          }
        />
      )}
    </>
  );
  // }
};

export default AddEmtAccount;
